import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { bindActionCreators, Dispatch } from 'redux';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { RootState } from 'types';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface ServerErrorProps {
    serverError: boolean;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface ServerErrorState {
    serverError: boolean;
}

class ServerError extends React.Component<ServerErrorProps, ServerErrorState> {
    constructor(props: ServerErrorProps) {
        super(props);
        this.state = {
            serverError: false,
        };
    }

    static getDerivedStateFromProps(props: ServerErrorProps, state: ServerErrorState) {
        if (props.serverError !== state.serverError) {
            return {
                serverError: props.serverError,
            };
        }
        return null;
    }

    render() {
        return (
            <>
                {this.state.serverError && (
                    <section className="z-100 fixed left-0 top-0 items-center justify-center inset-0 flex fixed-position w-full h-full   bg-white overflow-hidden">
                        <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="relative">
                                <Image src="/static/images/application-error.png" className="mx-auto" alt="error" />
                                <blockquote className="mt-8">
                                    <div className="max-w-3xl mx-auto text-center leading-9 font-sm text-gray-900">
                                        <p className="font-sm font-bold">{translate('Application Error')}</p>
                                        <p className="text-sm">
                                            {translate('Application error please contact your system administrator or')}
                                            <span
                                                className="text-blue-500 mx-1 cursor-pointer"
                                                onClick={() => {
                                                    this.props.setErrorHandlerAction({
                                                        /* @ts-ignore */
                                                        response: { status: 100 },
                                                    });
                                                }}
                                            >
                                                {translate('click here')}
                                            </span>
                                            {translate('to try again')}
                                        </p>
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </section>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    serverError: state.errors.serverError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ServerError));
